export const HOCKEY_POSITIONS = [
  { pos: 1, label: "C", value: 13, name: "Center" },
  { pos: 2, label: "D", value: 14, name: "Defenseman" },
  { pos: 3, label: "LW", value: 16, name: "Left Wing" },
  { pos: 4, label: "RW", value: 15, name: "Right Wing" },
];

export const SOCCER_POSITIONS = [
  { pos: 1, label: "D", value: 1, name: "Defender" },
  { pos: 2, label: "M", value: 2, name: "Midfielder" },
  { pos: 3, label: "F", value: 3, name: "Forward" },
  { pos: 4, label: "G", value: 4, name: "Goalkeeper" },
];

export const BASKETBALL_POSITIONS = [
  { pos: 1, label: "BG", value: 5, name: "Guard" },
  { pos: 2, label: "BF", value: 6, name: "Forward" },
  { pos: 3, label: "BC", value: 7, name: "Center" },
];

export const FOOTBALL_POSITIONS = [
  { pos: 1, label: "QB", value: 25, name: "Quarterback" },
  { pos: 2, label: "WR", value: 26, name: "Wide Receiver" },
  { pos: 3, label: "TE", value: 27, name: "Tight End" },
  { pos: 4, label: "RB", value: 28, name: "Running Back" },
  { pos: 5, label: "G", value: 29, name: "Guard" },
  { pos: 6, label: "C", value: 30, name: "Center" },
  { pos: 7, label: "DT", value: 31, name: "Defensive Tackle" },
  { pos: 8, label: "DE", value: 32, name: "Defensive End" },
  { pos: 9, label: "CB", value: 33, name: "Cornerback" },
  { pos: 10, label: "FK", value: 34, name: "Kicker" },
  { pos: 11, label: "FL", value: 35, name: "Linebacker" },
  { pos: 12, label: "FS", value: 36, name: "Safety" },
  { pos: 13, label: "FT", value: 37, name: "Tackle" },
];

export const RUGBY_POSITIONS = [
  { pos: 1, label: "FB", value: 18, name: "Fullback" },
  { pos: 4, label: "HA", value: 21, name: "Halves" },
  { pos: 5, label: "HK", value: 22, name: "Hooker" },
  { pos: 6, label: "MF", value: 23, name: "Middle Forward" },
  { pos: 7, label: "EF", value: 24, name: "Edge Forward" },
];

export const AUSTRALIAN_FOOTBALL_POSITIONS = [
  { pos: 1, label: "D", value: 1, name: "Defender" },
  { pos: 2, label: "M", value: 2, name: "Midfielder" },
  { pos: 3, label: "F", value: 3, name: "Forward" },
  { pos: 4, label: "R", value: 17, name: "Ruck" },
];

export const CRICKET_POSITIONS = [
  { pos: 1, label: "BL", value: 8, name: "Bowler" },
  { pos: 2, label: "BT", value: 9, name: "Batsman" },
  { pos: 4, label: "AR", value: 11, name: "All Rounder" },
];

export const getPositionsForSport = (sport) => {
  if (sport === "soccer") return SOCCER_POSITIONS;
  if (sport === "basketball") return BASKETBALL_POSITIONS;
  if (sport === "football") return FOOTBALL_POSITIONS;
  if (sport === "rugby") return RUGBY_POSITIONS;
  if (sport === "australian_football") return AUSTRALIAN_FOOTBALL_POSITIONS;
  if (sport === "cricket") return CRICKET_POSITIONS;
  return HOCKEY_POSITIONS;
};
